import { useWhen } from '@speedlo/hooks'
import { Map } from 'mapbox-gl'
import React from 'react'

import { useMap } from './useMap'

type TOptions<TElement> = {
  onCreate(): TElement
}

type TBaseElement = {
  addTo(map: Map): void
  remove(): void
}

export function useMapElement<TElement extends TBaseElement>({
  onCreate,
}: TOptions<TElement>) {
  const mapModel = useMap()
  const [element, setElement] = React.useState<TElement>()

  useWhen(
    () => mapModel.isReady,
    () => {
      const _element = onCreate()
      _element.addTo(mapModel.map!)
      setElement(_element)
    },
  )

  React.useEffect(() => {
    return () => {
      element?.remove()
    }
  }, [element])

  return element
}
